import { useState } from 'react'

/**
 * Modal variant for multi-line text. Available for plugin authors who want
 * `type: textarea` at the top level; CollectionEditor cells use TextareaCell
 * directly (inline) and won't open this modal.
 */
export const TextareaEditor = ({ value, label, onSave, onClose }) => {
  const [text, setText] = useState(value ?? '')

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') onClose()
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) onSave(text)
  }

  return (
    <div className="flex flex-col gap-3">
      <textarea
        value={text}
        onChange={e => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={label}
        autoFocus
        rows={6}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent resize-y"
        aria-label={label}
      />
      <div className="builder-editor-actions">
        <button
          onClick={onClose}
          className="btn btn-secondary"
        >
          Annuler
        </button>
        <button
          onClick={() => onSave(text)}
          className="btn btn-primary"
        >
          Appliquer
        </button>
      </div>
    </div>
  )
}
